<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>시스템 관리</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">시스템 관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">부서관리</p>
          <ul class="depth">
            <li><router-link to="/usermanagement" title="사용자관리">사용자관리</router-link></li>
            <li><router-link to="/teamlist" title="팀관리">팀관리</router-link></li>
            <li><router-link to="/departmentlist" title="부서관리">부서관리</router-link></li>
            <li><router-link to="/menulist" title="메뉴관리">메뉴관리</router-link></li>
            <li><router-link to="/userauthoritylist" title="사용자권한관리">사용자권한관리</router-link></li>
            <li><router-link to="/accessinfo" title="접속정보">접속정보</router-link></li>
            <!-- <li><router-link to="/connertmenustat" title="메뉴접속통계">메뉴접속통계</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">부서관리</h3>
        <article>
          <div class="searchArea">
            <div class="total">
              총<span>{{ listData.length }}</span
              >건
            </div>
            <div class="search-box">
              <search-box @emitSearch="searchBtn" @emitPerChange="changePerPage">
                <template slot="searchCondition">
                  <option value="1">부서명</option>
                  <option value="2">부서설명</option>
                  <option value="3">부서명 + 부서설명</option>
                </template>
              </search-box>
            </div>
          </div>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table vertical-table">
              <table>
                <caption>
                  부서관리 테이블
                </caption>
                <thead>
                  <tr>
                    <th scope="col">번호</th>
                    <th scope="col">부서 아이디</th>
                    <th scope="col">부서명</th>
                    <th scope="col">부서설명</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="nodate" v-if="nodata">
                    <td colspan="4">조회된 데이터가 없습니다.</td>
                  </tr>
                  <tr v-for="(item, index) in calData" :key="index" @click="view(item.deptId)">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.deptId }}</td>
                    <td>{{ item.deptNm }}</td>
                    <td>{{ item.deptDc }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--btnArea-->
          <div class="btnArea txt-right">
            <button type="button" class="btn border" @click="$router.push('departmentenrollment')">등록</button>
          </div>

          <!-- 페이지네이션 -->
          <v-pagination v-model="curPageNum" :length="numOfPages"></v-pagination>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from 'axios';
import SearchBox from '../../../components/SearchBox.vue';

export default {
  data() {
    return {
      listData: [],
      curPageNum: 1,
      dataPerPage: 10,
      searchCondition: '',
      searchKeyword: '',
      nodata: true,
    };
  },

  mounted() {
    this.searchBtn();
  },

  components: {
    SearchBox,
  },

  methods: {
    async searchBtn(searchCondition, searchKeyword) {
      await axios
        .get('/api/dept/list.json', {
          params: {
            searchCondition: searchCondition,
            searchKeyword: searchKeyword,
          },
        })
        .then(response => {
          var data = response.data;

          if (data.resultList && data.resultList.length > 0) {
            this.listData = data.resultList;
            this.nodata = false;
          } else {
            this.listData = [];
            this.nodata = true;
          }

          this.curPageNum = 1;
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    changePerPage(dataPerPage) {
      this.dataPerPage = dataPerPage;
      this.curPageNum = 1;
    },

    view(deptId) {
      this.$router.push({
        path: 'departmentview',
        query: { deptId: deptId },
      });
    },
  },

  computed: {
    startOffset() {
      return (this.curPageNum - 1) * this.dataPerPage;
    },
    endOffset() {
      return this.startOffset + this.dataPerPage;
    },
    numOfPages() {
      return Math.ceil(this.listData.length / this.dataPerPage);
    },
    calData() {
      if (this.listData.length) {
        return this.listData.slice(this.startOffset, this.endOffset);
      }
    },
  },
};
</script>
